import { Box, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import muiSytle from "../../style/components-style/muiStyle";
import DownloadComponentButton from "../button/DownloadComponentButton";
import { useGetColor } from "./Colors";

const calculateMaxLabelWidth = (labels, font = "14px Poppins") => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = font;
  let maxWidth = 0;
  labels.forEach((label) => {
    const width = context.measureText(label).width;
    if (width > maxWidth) maxWidth = width;
  });
  maxWidth += context.measureText("----").width;
  return Math.ceil(maxWidth);
};
// const CustomTooltip = ({ active, payload, label }) => {
//   const sx = { fontFamily: "Poppins", fontSize: "14px" };
//   if (active && payload && payload.length) {
//     return (
//       <Box sx={{ borderRadius: "8px", backgroundColor: "white", padding: 1 }}>
//         <Typography sx={{ ...sx, color: "#333" }}>{label}</Typography>
//         {[...payload].map((entry, index) => (
//           <Box key={index} sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
//             <Typography sx={{ ...sx, color: entry.color }}>{entry.name}:</Typography>
//             <Typography sx={{ ...sx, color: entry.color }}>{entry.value}</Typography>
//           </Box>
//         ))}
//       </Box>
//     );
//   }
//   return null;
// };
const VerticalStackedBarChart = ({ title, data = [], dataKeys = ["uv", "pv", "amt"], getColor }) => {
  const { t } = useTranslation();
  const [yAxisWidth, setYAxisWidth] = useState(10);
  const [visibility, setVisibility] = useState(false);
  const ref = useRef(null);
  const getDefaultColor = useGetColor();
  useEffect(() => {
    const width = calculateMaxLabelWidth(
      data.map((d) => d.label),
      "14px Poppins"
    );
    setYAxisWidth(width);
  }, [data]);

  return (
    <Box onMouseEnter={() => setVisibility(true)} onMouseLeave={() => setVisibility(false)} sx={{ width: "100%", position: "relative" }}>
      <Box sx={{ position: "absolute", top: "5px", right: "5px" }}>
        <DownloadComponentButton ref={ref} filename={title + ".png"} visibility={visibility} />
      </Box>
      <Box ref={ref} sx={{ backgroundColor: "white", padding: 1 }}>
        <Box sx={{ paddingTop: 1, paddingBottom: 2 }}>
          <Typography variant="Chart Title">{t(title)}</Typography>
        </Box>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip
              contentStyle={{
                fontFamily: "Poppins",
                fontSize: "14px",
                color: "#333",
                borderRadius: "8px",
              }}
              formatter={(value, name) => [value, t(name)]}
            />
            {dataKeys.map((d, index) => (
              <Bar key={d} dataKey={d} stackId="stack" fill={getColor ? getColor(index, dataKeys.length) : getDefaultColor(index, dataKeys.length)} />
            ))}
            <Legend formatter={(value) => t(value)} layout="horizontal" verticalAlign="top" align="center" iconType="circle" iconSize={18} />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default VerticalStackedBarChart;
